<template>
  <div class="ScreenSharingPanel">
    <div class="scs-container">

      <!-- Toolbar -->
      <div class="scs-bar">
        <p class="scs-bar-name">{{"Bildschirmübertragung von " + (localUserIsModerator ? localUserName : getUserName(videoStreams[0].connection.data.user_id))}}</p>
        <div class="scs-bar-buttons">  
          <md-button class="md-icon-button" @click="toggleScreenSharing()" style="margin-right: 0;" v-show="localUserIsModerator">
            <CloseIcon class="closeIcon"/>
          </md-button>
        </div> 
      </div>

      <!-- Screencast Video -->
      <div class="scs-content">
        <FluxComPublisher screencast :opts="publishingProperties" where="video-session" v-if="localUserIsModerator && !openTokStreams.find( x => x.videoType === 'screen')"/> <!-- Only publish when no one else is streaming -->
        <FluxComSubscriber :stream="videoStreams[0]" :opts="videoProperties(videoStreams[0])" v-else/>  
      </div>

    </div>  
  </div>
</template>

<style scoped>
  .ScreenSharingPanel{
    width: 100%;
    height: 100%; 
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #000000d0;
    z-index: 5;
    top: 0;
  }
  .scs-container {
    position: absolute;
    background: white;
    border-radius: 10px;
    transition: width .4s ease, height .4s ease;
    overflow: hidden;
    width: 88%;
    height: 88%;
  }
  .scs-bar{
    height: 46px;
    padding: 3px;
    padding-right: 5px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.774);
    display: flex;
    position: relative;
  }
  .scs-bar-name{
    width: 100%;
    text-align: center;
    font-size: 18px;
    margin: auto 0;
  }
  .scs-bar-buttons{
    margin-left: auto;
  }
  .scs-content{
    width: 100%;
    height: calc(100% - 46px);
  }
  .scs-content .OT_root{
    width: 100% !important;
    height: 100% !important;
  }
  .material-design-icon.closeIcon {
    height: 2.5em;
    width: 2.5em;
  }
  .material-design-icon.closeIcon> .material-design-icon__svg {
    fill: rgb(252, 113, 113);
    height: 2.5em;
    width: 2.5em;
  }
  .md-button{
    background: transparent;
    padding: 0;
    width: 30px;
  }
</style>
    
<script>
import {mapGetters, mapState} from 'vuex';

import CloseIcon from 'vue-material-design-icons/Close.vue'

export default {
  components: {CloseIcon},
  inject: ['toggleScreenSharing'],
	data: () => ({
    videoPropertyDefault: {
      fitMode: 'contain',
      insertDefaultUI: true,
      resolution: '320x240',
      showControls: true,
      audioLevelDisplayMode: 'auto',
      buttonDisplayMode: 'auto',
      nameDisplayMode: 'off',
		},
	}),
	computed: {
		...mapState({
			openTokStreams: (state) => state.session.openTokStreams,
		}),
		...mapGetters(['localUser','users']),
		localUserName(){
			return this.localUser.getName();
		},
		videoStreams() {
			return this.openTokStreams.filter( x => x.videoType === 'screen');
    },
    publishingProperties() {
      return {
        width: window.screen.width * 0.6,
        height: window.screen.height * 0.6,
        maxResolution: { width: 1920, height: 1080 },
        frameRate: 30,
      };
    },
    localUserIsModerator() {
			return this.localUser && this.localUser.getRole() === "moderator"
		},
  },
	methods: {
		getUserName(userID) {
			let user = this.users.filter(x => x.getID() === userID);
			if (user.length > 0) {
				return user[0].getName();
			}
			return "";
		},
		videoProperties(stream) {
			let vp = {...this.videoPropertyDefault};
			if (stream.videoDimensions) {
				vp.width = Math.min( stream.videoDimensions.width, window.screen.width * 0.6 );
				vp.height = Math.min( stream.videoDimensions.height, window.screen.height * 0.6 );
			}

			return vp;
		}   
  }
}
</script>
